import { PreviewAddonRequest } from "@client/requests";
import {
  SubscriptionPlanPreviewResource,
  subscriptionPlanPreviewResourceSchema,
} from "@client/resources/SubscriptionPlanPreviewResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type PostCheckoutAddonPreviewResponse =
  ApiResponse<SubscriptionPlanPreviewResource>;

const postCheckoutAddonPreviewResponseSchema = object({
  data: subscriptionPlanPreviewResourceSchema.defined(),
});

export const postCheckoutAddonPreview = async (
  payload: PreviewAddonRequest,
): Promise<PostCheckoutAddonPreviewResponse> => {
  const response = await fetchData(
    "/dietitian/checkout/addon/preview",
    APIMethods.POST,
    payload,
  );

  return await postCheckoutAddonPreviewResponseSchema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/checkout/addon/preview"));
};
